import React, { useEffect, useState } from 'react';
import { ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faGripVertical, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Button, Popover } from 'antd';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Input, FormGroup } from 'reactstrap';
import './GetModalForEditColumns.css';
import { first } from '../../../common/util/appUtils'; 
import { useSelector, useDispatch } from 'react-redux';
import { setTaskColumnsOrder } from '../../../Context/ReduxTimerSlice';
import { faEye } from '@fortawesome/free-regular-svg-icons';

const listStyle = {
  minHeight: '100px',
  padding: '4px',
};

const itemStyle = (isDragging) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: isDragging ? '#e6f7ff' : '#f5f5f5',
  padding: '6px',
  marginBottom: '.5em',
  borderRadius: '4px',
});

export default function GetModalForEditColumns({ selected, setSelected }) {
  const [searchValue, setSearchValue] = useState('');
  const taskColumnsOrder = useSelector((state) => state.TimeTrackingSlice.taskColumnsOrder);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
const [selectedItems, setSelectedItems] = useState(['Task Name']);

// useEffect(() => { 
//   if (!selected) return;
//   console.log(Array.from(new Set(['Task Name', ...Object.keys(selected).filter(k => selected[k] == true)])))
//   setSelectedItems(Array.from(new Set(['Task Name', ...Object.keys(selected).filter(k => selected[k] == true)])));
// }, [selected]);
useEffect(() => {
  if (!selected) return;
  let selectedColumns = ['Task Name'];
  const selectedKeys = Object.keys(selected).filter(k => selected[k] === true);
  const orderedSelectedColumns = taskColumnsOrder.filter(label => selectedKeys.includes(label));
  selectedColumns = [...selectedColumns, ...orderedSelectedColumns];
  setSelectedItems(Array.from(new Set(selectedColumns)));
}, [selected]);

useEffect(() => {
  if (!taskColumnsOrder) return; 
  const selectedKeys = Object.keys(selected).filter(key => selected[key] === true); 
  const ordered = taskColumnsOrder.filter(key => key !== 'Task Name' && selectedKeys.includes(key)); 
  const final = ['Task Name', ...ordered]; 
  setSelectedItems(final);
}, [taskColumnsOrder]);


const handleSelect = (item) => {
    if (item === 'Task Name' || selectedItems.includes(item)) return;
    setSelected(prev => ({ ...prev, [item]: true }));
    setSelectedItems(prev => [...prev, item]);
  };

  const handleRemove = (item) => {
    if (item === 'Task Name') return;
    setSelected(prev => ({ ...prev, [item]: false }));
    setSelectedItems(prev => prev.filter(i => i !== item));
  };
const handleSetAll = () => {
  const allSelectable = first.filter(item => item !== 'Task Name');
  const newSelected = { 'Task Name': true };
  allSelectable.forEach(item => {
    newSelected[item] = true;
  });
  setSelected(newSelected);
  setSelectedItems(['Task Name', ...allSelectable]);
};
 
const handleResetAll = () => {
  setSelected({ 'Task Name': true });
  setSelectedItems(['Task Name']);
};
  const onDragEnd = (result) => { 
    if (!result.destination || result.destination.index == 0) return;
    const reordered = Array.from(selectedItems);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    const visibleColumns = ['Task Name', ...reordered.filter(col => col !== 'Task Name')];
    setSelectedItems(visibleColumns); 
    const visibleSet = new Set(visibleColumns);
    const newReduxOrder = [...visibleColumns, ...taskColumnsOrder.filter(col => !visibleSet.has(col))];
    dispatch(setTaskColumnsOrder(newReduxOrder));
  };

  const content = () => (
    <ModalBody style={{ minWidth: '550px' }}>
      <FormGroup className="pos-relative editcol-searchpad" style={{ marginBottom: '14px', height: 'auto', padding:'5px' }}>
        <Input
          type="text"
          placeholder="Search available fields"
          className="pad-fix search-filter"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </FormGroup> 
      <div style={{ display: 'flex', gap: '32px' }}> 
        <div style={{ flex: 1, border: '1px solid #ddd', borderRadius: '4px', padding: '12px' }}>
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between',marginBottom:'3px'}}><h6 style={{ fontWeight: 600, marginTop: '-6px' }}>Available Fields</h6> 
          <Button style={{ height: 'auto',minWidth: '26px', bottom: '5px'}} shape='circle'>{(first.length - selectedItems.length)}</Button></div>
          <ul style={{ listStyle: 'none', padding: 0,
            maxHeight: first.length > 10 ? "300px" : "auto",
            overflowY: first.length > 10 ? "auto" : "visible",
           }}>
            {first
              .filter(item => item.toLowerCase().includes(searchValue.toLowerCase()))
              .map(item => (
                <li
                  key={item}
                  className='toSelectItems'
                  style={{background: selectedItems.includes(item) ? 'rgb(245, 245, 245)' : 'rgb(240 239 239)',
                    pointerEvents: item === 'Task Name' ? 'none' : 'auto',
                    opacity: item === 'Task Name' ? '0.5' : '1',
                  }}
                  onClick={() => handleSelect(item)}
                >
                  <span style={{opacity: selectedItems.includes(item) && item !== 'Task Name' ? '0.5' : '1', flexGrow: 1 }}>{item}</span>
                  {item=="Task Name" && <small>{'Primary Field'}</small>}
                  {!selectedItems.includes(item) && <FontAwesomeIcon icon={faArrowRight}/>}
                </li>
              ))}
            {first.filter(item => item.toLowerCase().includes(searchValue.toLowerCase())).length === 0 && (
              <li style={{ textAlign: 'center', color: '#888', padding: '8px' }}>No fields available</li>
            )}
          </ul>
              <br></br><Button size="small" onClick={handleSetAll}>Select All</Button>
        </div> 
        <div style={{ flex: 1, border: '1px solid #ddd', borderRadius: '4px', padding: '12px', height:"420px" }}>
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', paddingTop:'3px'}}><h6 style={{ fontWeight: 600 }}>Selected Fields</h6> 
          <Button style={{ height: 'auto',minWidth: '26px', bottom: '5px'}} shape='circle'>{selectedItems.length}</Button></div>
          <DragDropContext onDragEnd={onDragEnd}>
  <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Droppable droppableId="selected-columns">
              {(provided) => (
                <ul
          style={{
            ...listStyle,
            flexGrow: 1,
            overflowY: 'auto',
            marginBottom: '38px',
      }}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {selectedItems.map((item, index) => (
                    <Draggable key={item} draggableId={item} index={index}>
                      {(provided, snapshot) => (
                        <li
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="selectedFieldItem"
                          style={item !== 'Task Name' ?{
                            ...itemStyle(snapshot.isDragging),
                            ...provided.draggableProps.style, 
                          }:{pointerEvents: 'none', opacity: 0.6}}
                        >
                          <FontAwesomeIcon icon={faGripVertical} style={{ marginRight: '8px', cursor: 'grab' }} />
                          <span style={{ flexGrow: 1 }}>{item}</span>
                          {item=="Task Name" && <small>{'Primary Field'}</small>}
                          <FontAwesomeIcon
                            icon={faTimes}
                            style={{ cursor: 'pointer', color: '#e04343ff' }}
                            onClick={() => handleRemove(item)}
                          />
                        </li>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                  {selectedItems.length === 0 && (
                    <li style={{ textAlign: 'center', color: '#888', padding: '8px' }}>No fields selected</li>
                  )}
                </ul>
              )}
            </Droppable>
    <div style={{marginBottom : "36px"}}>
      <Button size="small" onClick={handleResetAll}>Reset All</Button>
    </div>
  </div>
          </DragDropContext>
        </div>
      </div>
    </ModalBody>
  );

  return (
    <Popover
      content={content}
      rootClassName="custom-popover-tasks-manage-columns"
      title="Manage Columns"
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      placement="bottomLeft"
    >
      <Button type="default"><FontAwesomeIcon color='#95c4ff' icon={faEye}/>Fields to Display <div className='count-badge'>{selectedItems.length}</div></Button>
    </Popover>
  );
}
